import { render, staticRenderFns } from "./addBaseActive.vue?vue&type=template&id=5a7003c4&scoped=true"
import script from "./addBaseActive.vue?vue&type=script&lang=js"
export * from "./addBaseActive.vue?vue&type=script&lang=js"
import style0 from "./addBaseActive.vue?vue&type=style&index=0&id=5a7003c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7003c4",
  null
  
)

export default component.exports